"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Suggestion = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _Tile = require("./Tile");

var _atoms = require("../../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Suggestion = ({
  isSelected,
  iconName,
  label,
  onClickAdd,
  ...rest
}) => {
  return /*#__PURE__*/_react.default.createElement(_styles.SuggestionContainerStyle, null, /*#__PURE__*/_react.default.createElement(_Tile.IconTile, {
    iconName: iconName,
    label: label
  }), /*#__PURE__*/_react.default.createElement(_atoms.ButtonWithIcon, {
    emphasis: "high",
    icon: "Add",
    iconPosition: "left",
    isPrimary: false,
    onClick: () => onClickAdd({
      isSelected,
      iconName,
      label,
      onClickAdd,
      ...rest
    }),
    text: isSelected ? 'Added' : 'Add',
    theme: "light"
  }));
};

exports.Suggestion = Suggestion;
Suggestion.defaultProps = {
  iconName: '',
  label: '',
  isSelected: false
};
Suggestion.propTypes = {
  iconName: _propTypes.default.string,
  label: _propTypes.default.string,
  isSelected: _propTypes.default.bool,
  onClickAdd: _propTypes.default.func
};